export default {
  accepted: {
    title: 'Подпись принята',
    description: 'Подпись принята. Спасибо, что воспользовались нашей службой доставки!',
  },
  info: 'У вас доставка от',
  title: 'Пожалуйста, проверьте вашу информацию:',
  fields: {
    name: 'Имя получателя:',
    phone: 'Телефон получателя:',
    address: 'Адрес получателя:',
    'rx-number': 'Номер рецепта:',
  },
  'action-btn': 'Отправить',
  'empty-signature': 'Пожалуйста, нарисуйте подпись перед отправкой.',
  'heading-required': 'Требуется подпись',
  'heading-optional': 'Подпись необязательна',
  'heading-change': 'Вы уже подписали. Хотите изменить подпись?',
}
